import {Form} from "formik";
import {LoadingButton} from "@mui/lab";
import {styled, Button, Divider, Container} from "@mui/material";

export const ReturnButton = styled(Button)(() => ({
    color: "white",
    marginBottom: 15,
    backgroundColor: "black"
}))

export const FormContainer = styled(Form)(() => ({
    margin: 15,
    marginBottom: 25
}))

export const SubmitButton = styled(LoadingButton)(() => ({
    width: 400
}))

export const UploadContainer = styled('div')(() => ({
    width: 400,
}))

export const ImageContainer = styled('img')(() => ({
    width: 50,
    height: 50,
    borderRadius: 10,
    objectFit: 'cover'
}))

export const Cover = styled('img')(({src, alt, ...rest}) => ({
    width: 300,
    height: 300,
    borderRadius: 10,
    objectFit: 'cover',
    alt: `${alt || '...'}`,
    content: `url(${src || '/static/noImage.svg'})`,
    ...rest
}))

export const DeleteButtonContainer = styled('div')(() => ({
    width: 20,
    height: 20,
    left: 40,
    bottom: 55,
    position: 'relative',
    borderRadius: 50,
    backgroundColor: 'white',
}))

export const DividerContainer = styled(Divider)(() => ({
    width: 300,
    marginBottom: 15,

}))

export const CenterContainer = styled(Container)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}))

export const OtherImagesContainer = styled(CenterContainer)(() => ({
    marginTop: 20
}))

export const CoverContainer = styled(CenterContainer)(() => ({
    width: 300,
    borderRadius: 10,
    objectFit: 'cover',
}))

